import { TenantEntity } from '../TenantEntity'

export class WarehouseInfo extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'WarehouseInfo'
  }
  // ----- 非数据库字段
  get deleted() {
    return this._data.deleted
  }
  set deleted(deleted) {
    this._data.deleted = deleted || false
  }

  get warehouseId() {
    return this._data.warehouseId
  }
  set warehouseId(warehouseId) {
    this._data.warehouseId = warehouseId || 0
  }
  get warehouseCmp() {
    return this._data.warehouseCmp
  }
  set warehouseCmp(warehouseCmp) {
    this._data.warehouseCmp = warehouseCmp || 0
  }
  get arriveDate() {
    return this._data.arriveDate
  }
  set arriveDate(arriveDate) {
    this._data.arriveDate = arriveDate
  }
  get warehouseContact() {
    return this._data.warehouseContact
  }
  set warehouseContact(warehouseContact) {
    this._data.warehouseContact = warehouseContact
  }
  get warehouseContactTel() {
    return this._data.warehouseContactTel
  }
  set warehouseContactTel(warehouseContactTel) {
    this._data.warehouseContactTel = warehouseContactTel
  }
  get frontEndWarehouse() {
    return this._data.frontEndWarehouse
  }
  set frontEndWarehouse(frontEndWarehouse) {
    this._data.frontEndWarehouse = frontEndWarehouse
  }
  get warehouseContactFax() {
    return this._data.warehouseContactFax
  }
  set warehouseContactFax(warehouseContactFax) {
    this._data.warehouseContactFax = warehouseContactFax
  }
  get warehouseAddress() {
    return this._data.warehouseAddress
  }
  set warehouseAddress(warehouseAddress) {
    this._data.warehouseAddress = warehouseAddress
  }
  get remarks() {
    return this._data.remarks
  }
  set remarks(remarks) {
    this._data.remarks = remarks
  }
  get quantity() {
    return this._data.quantity
  }
  set quantity(quantity) {
    this._data.quantity = quantity || 0
  }
  get warehouseName() {
    return this._data.warehouseName
  }
  set warehouseName(warehouseName) {
    this._data.warehouseName = warehouseName
  }
  get mapFile() {
    return this._data.mapFile
  }
  set mapFile(mapFile) {
    this._data.mapFile = mapFile
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
}
